/** Native disclosures stay usable without JavaScript; enhance the size shortcut. */
class SizeGuideLink extends HTMLElement {
  connectedCallback() { this.addEventListener('click', this.openGuide); }
  disconnectedCallback() { this.removeEventListener('click', this.openGuide); }
  openGuide = (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a');
    if (!link) return;
    const guide = document.getElementById(link.hash.slice(1));
    if (!(guide instanceof HTMLDetailsElement)) return;
    guide.open = true;
    // Preserve the native fragment jump, URL and focus behavior.
  };
}
if (!customElements.get('size-guide-link')) customElements.define('size-guide-link', SizeGuideLink);
